const { prop, isNil } = require('ramda');
module.exports = (value) => {
  if (typeof value === 'object') {
    return prop('name')(value);
  }
  return isNil(value) ? '' : value;
};
